import type { LanguageInfo } from 'src/types/reportConfig';

export const LANGUAGE = {
  EN: 0, // English
  DE: 1, // German
  ES: 2, // Spanish
  FR: 3, // French
  NL: 4, // Dutch
  PL: 5, // Polish
  PT: 6, // Portuguese
  RU: 7, // Russian
  SV: 8, // Swedish
  IT: 9, // Italian
  CS: 10, // Czech
  HU: 11, // Hungarian
  SK: 12, // Slovak
  SL: 13, // Slovenian
};
Object.freeze(LANGUAGE);

export const LANGUAGE_MAP: LanguageInfo[] = [
  {
    code: LANGUAGE.EN,
    abbreviation: 'en',
  },
  {
    code: LANGUAGE.DE,
    abbreviation: 'de',
  },
  {
    code: LANGUAGE.ES,
    abbreviation: 'es',
  },
  {
    code: LANGUAGE.FR,
    abbreviation: 'fr',
  },
  {
    code: LANGUAGE.NL,
    abbreviation: 'nl',
  },
  {
    code: LANGUAGE.PL,
    abbreviation: 'pl',
  },
  {
    code: LANGUAGE.PT,
    abbreviation: 'pt',
  },
  {
    code: LANGUAGE.RU,
    abbreviation: 'ru',
  },
  {
    code: LANGUAGE.SV,
    abbreviation: 'sv',
  },
  {
    code: LANGUAGE.IT,
    abbreviation: 'it',
  },
  {
    code: LANGUAGE.CS,
    abbreviation: 'cs',
  },
  {
    code: LANGUAGE.HU,
    abbreviation: 'hu',
  },
  {
    code: LANGUAGE.SK,
    abbreviation: 'sk',
  },
  {
    code: LANGUAGE.SL,
    abbreviation: 'sl',
  },
];
Object.freeze(LANGUAGE_MAP);

export const DEFAULT_LANGUAGE_CODE = 'en';
